module.exports = __webpack_public_path__ + "static/pic15-33f7e45af77320f19350e370f2402c24.png";